export const membershipPlans = [
    {
        id: '15min',
        name: "Quick Session",
        duration: "15 minutes",
        price: "$1",
        originalPrice: "$1",
        description: "Perfect for quick learning sessions",
        features: [
            "15 minutes of AI tutoring",
            "Basic learning materials",
            "Progress tracking",
            "Email support"
        ],
        isPopular: false,
        color: "blue"
    },
    {
        id: '1h',
        name: "Standard Session",
        duration: "1 hour",
        price: "$29",
        originalPrice: "$29",
        description: "Ideal for comprehensive learning",
        features: [
            "1 hour of AI tutoring",
            "Advanced learning materials",
            "Progress tracking & analytics",
            "Priority support",
            "Session recordings"
        ],
        isPopular: true,
        color: "green"
    },
    {
        id: '15h',
        name: "Extended Learning",
        duration: "15 hours",
        price: "$299",
        originalPrice: "$299",
        description: "For intensive learning programs",
        features: [
            "15 hours of AI tutoring",
            "Premium learning materials",
            "Advanced progress tracking",
            "24/7 priority support",
            "All session recordings",
            "Personalized learning path",
            "Monthly progress reports"
        ],
        isPopular: false,
        color: "purple"
    }
];

export const getMembershipPlanById = (id) => {
    return membershipPlans.find(plan => plan.id === id);
};
